/* Nutrition For Pets: arrows for the photo-tile carousel (also works after sections reload in the editor) */
(function () {
  function state(sec) {
    var tr = sec.querySelector('[data-nptl-track]');
    if (!tr) return;
    var prev = sec.querySelector('[data-nptl-prev]'), next = sec.querySelector('[data-nptl-next]');
    var max = tr.scrollWidth - tr.clientWidth - 2;
    if (prev) prev.classList.toggle('is-off', tr.scrollLeft <= 2);
    if (next) next.classList.toggle('is-off', tr.scrollLeft >= max);
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('.nptl'), state); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-nptl-prev],[data-nptl-next]') : null;
    if (!b) return;
    var sec = b.closest('.nptl'), tr = sec && sec.querySelector('[data-nptl-track]');
    if (!tr) return;
    var tile = tr.querySelector('.nptl__tile');
    var step = (tile ? tile.getBoundingClientRect().width : 260) + 16;
    var from = tr.scrollLeft, to = Math.max(0, Math.min(tr.scrollWidth - tr.clientWidth, from + (b.hasAttribute('data-nptl-next') ? step : -step))), t0 = null;
    tr.style.scrollSnapType = 'none';
    (function tick(ts) {
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / 380);
      tr.scrollLeft = from + (to - from) * (1 - Math.pow(1 - k, 3));
      if (k < 1) setTimeout(function () { tick(performance.now()); }, 16); else { tr.style.scrollSnapType = ''; state(sec); }
    })(performance.now());
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-nptl-track]')) state(e.target.closest('.nptl'));
  }, true);
  window.addEventListener('resize', all);
  document.addEventListener('shopify:section:load', all);
  if (document.readyState !== 'loading') all(); else document.addEventListener('DOMContentLoaded', all);
})();
